
import DiscountShape from "../../../assets/filled/DiscountShape.svg";

import { IconProps } from "../../../types";

const cx = require('classnames');

export default function DiscountShapeIcon({ className, dataTestid = "DiscountShapeIcon", ...rest }: IconProps) {
  const classes = cx(className);

  return (
    <DiscountShape data-testid={dataTestid} className={classes} {...rest} />
  );
}
